import store from "store/store";
import event from "plugins/event";

// This instance is the actual system
// performing the upload
const uploader = new plupload.Uploader({
    url: process.env.VUE_APP_BASE_URL + "/files/upload",
    chunk_size: "500kb",
    // Dummy drop element
    drop_element: document.createElement("div"),
    max_retries: 3,
    required_features: {
        send_browser_cookies: true
    }
});

// Any error
uploader.bind("Error", function(up, error) {
    store.commit("flash/addFlash", {
        type: "error",
        message: error.message,
        onlyCurrentRoute: true
    });
}.bind(this));

// We add a UID to each query, so server can use that to
// generate unique enough upload.
uploader.bind("BeforeUpload", function(up, file) {
	var uuid = cuid();
	up.settings.params = {
        uuid: uuid,
        mime: file.type
    };
	up.settings.multipart_params = {
        uuid: uuid,
        mime: file.type
    };
});

// Upload progress - we report to the store
uploader.bind("UploadProgress", function(up, file) {
    for (let i = 0, l = file.length; i < l; i++) {
        store.commit("upload/setUpload", file[i]);
    }
}.bind(this));

// A single file finish upload
uploader.bind("FileUploaded", function(up, file, info) {
    store.commit("upload/removeUpload", file);
    try {
        const response = JSON.parse(info.response);
        file.url = response.url;
        event.$emit("upload", file);
    } catch (e) {
        store.commit("flash/addFlash", {
            type: "error",
            message: e.message,
            onlyCurrentRoute: true
        });
    }
}.bind(this));

uploader.init();

// Exposing few functions to the system
const custom = {
    /**
     * Adding file to uploader.
     *
     * @param {File} file The file to add.
     */
    add: function(file) {
        uploader.addFile(file, file.name);
    },

    /**
     * Remove a file from the uploader.
     *
     * @param {File} file The file to remove.
     */
    remove: function(file) {
        var status_before = file.status;
        uploader.removeFile(file);
        if(uploader.state == plupload.STARTED && status_before == plupload.UPLOADING) {
            uploader.stop();
            uploader.start();
        }
    },

    /**
     * Starting the uploader.
     */
    start: function() {
        if (uploader.state !== plupload.STARTED) {
            uploader.start();
        }
    },

    /**
     * Stopping the uploader.
     */
    stop: function() {
        uploader.stop();
    }
};

export default custom;